module.exports = __webpack_public_path__ + "static/img/director.937bdab1.png";